import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { StudentTopMenuLayout } from '../../Layout/StudentTopMenu/StudentTopMenuLayout'
import { StudentActivitiesList } from './StudentActivitiesList'
import { StudentActivityReportList } from './StudentActivityReportList'

const Student911Activities = () => {
	const { studentId } = useParams()
	const { user } = useAuth()
	const isInstructorView = user?.role === 'Instructor'
	const effectiveStudentId = isInstructorView ? studentId : user?.id
	const [activeTab, setActiveTab] = useState('studentactivities')

	const toggle = (tab) => {
		if (activeTab !== tab) setActiveTab(tab)
	}

	return (
		<StudentTopMenuLayout activeMenu="Activity" pageName="Activities">
			<div className="card mb-4 shadow-sm" style={{ borderRadius: '8px' }}>
				{/*}
				<div className="card-header border-bottom d-flex justify-content-between align-items-center">
					<div className="d-flex align-items-center">
						<button
							type="button"
							className="btn btn-link p-0 me-2"
							data-bs-toggle="collapse"
							data-bs-target="#collapseActivities"
							aria-expanded="false"
							aria-controls="collapseActivities"
						>
							<i className="fa fa-chevron-down"></i>
						</button>
						<h5 className="mb-0 d-inline-block">Activities</h5>
					</div>
				</div>
				{*/}
				<div className="collapse" id="collapseActivities">
					<div className="card-body">
						<Nav tabs>
							<NavItem>
								<NavLink
									className={activeTab === 'studentactivities' ? 'active' : ''}
									onClick={() => toggle('studentactivities')}
									style={{ cursor: 'pointer' }}
								>
									Student Activities
								</NavLink>
							</NavItem>
							<NavItem>
								<NavLink
									className={activeTab === 'studentactivityreports' ? 'active' : ''}
									onClick={() => toggle('studentactivityreports')}
									style={{ cursor: 'pointer' }}
								>
									Student Activity Reports
								</NavLink>
							</NavItem>
						</Nav>

						<TabContent activeTab={activeTab} className="mt-3">
							<TabPane tabId="studentactivities">
								<StudentActivitiesList studentId={effectiveStudentId} isStudentView={!isInstructorView} />
							</TabPane>
							<TabPane tabId="studentactivityreports">
								<StudentActivityReportList studentId={effectiveStudentId} isStudentView={!isInstructorView} />
							</TabPane>
						</TabContent>
					</div>
				</div>
			</div>
		</StudentTopMenuLayout>
	)
}

export { Student911Activities }
